module.exports = __webpack_public_path__ + "img/William B Sellers - appointed by Ivey.f2bf26ea.jpg";